export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20warm%20toned%20background%20with%20soft%20gradients%20of%20deep%20crimson%20and%20dark%20amber%2C%20mysterious%20atmospheric%20texture%2C%20news%20media%20vibe%2C%20editorial%20aesthetic%2C%20dark%20corners%20with%20subtle%20light%20burst%2C%20minimalist%20abstract%20composition%20with%20warm%20earthy%20tones&width=1800&height=1000&seq=hero-bg-heiliao&orientation=landscape"
          alt="黑料入口背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 text-accent-400 text-sm font-medium mb-6">
              <i className="ri-fire-fill text-base"></i>
              <span>热门事件追踪 · 深度解读</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
              黑料入口
              <br className="sm:hidden" />
              <span className="text-accent-400">·</span>
              <span> 黑料百科知识解读科普平台</span>
            </h1>

            <p className="text-lg md:text-xl text-accent-500 font-label mb-8 tracking-wide">
              理性吃瓜，深度解读，满足你的求知欲
            </p>

            <p className="text-sm md:text-base text-background-200/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              黑料入口是一个专注于事件科普与深度解读的内容平台。我们每日追踪全网热门黑料事件，从事件背景、
              关键经过到各方回应，为读者呈现完整的事件图谱。平台覆盖娱乐八卦、社会热点、行业揭秘等多个领域，
              以百科式科普为核心，拒绝断章取义，坚持有理有据的解读方式。目前已累计盘点超过
              500 个事件专题，每日更新最新热点解读，让你不错过任何一个值得关注的精彩事件。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-background-200/80">
                <i className="ri-article-line text-accent-400"></i>
                <span className="text-sm">500+ 事件专题</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80">
                <i className="ri-time-line text-accent-400"></i>
                <span className="text-sm">每日实时更新</span>
              </div>
              <div className="flex items-center gap-2 text-background-200/80">
                <i className="ri-shield-check-line text-accent-400"></i>
                <span className="text-sm">多维度交叉验证</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#carousel"
                className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-compass-3-line"></i>
                浏览焦点专题
              </a>
              <a
                href="#index"
                className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-lg border border-background-50/25 hover:bg-background-50/25 transition-colors duration-200 whitespace-nowrap text-sm"
              >
                <i className="ri-book-open-line"></i>
                查看专题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-accent-500/10 rounded-2xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20style%20composition%20featuring%20stacked%20newspaper%20clippings%20and%20magnifying%20glass%20on%20dark%20wooden%20desk%2C%20warm%20candlelight%20glow%2C%20mysterious%20atmosphere%2C%20journalism%20investigation%20theme%2C%20rich%20textures%20of%20aged%20paper%20and%20leather%2C%20cinematic%20lighting%20with%20deep%20shadows&width=800&height=900&seq=hero-visual-heiliao&orientation=portrait"
                alt="黑料百科知识解读 - 事件深度调查"
                className="w-full rounded-2xl object-cover"
                style={{ aspectRatio: '4/5' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}